let list = [{
  id: 1,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_1%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/insurance_program_banner%402x.png',
  title: '互联网+保险',
  desc: '针对保险业务，打造移动分销平台、电商平台、微信理赔在线平台、及任务管理平台，为保险企业增加线上销售渠道，提升保险服务的便捷性，加大对保险从业人员的行为管控，实现保险行业内从销售、服务到管理的移动端闭环应用体系。',
  program: [{
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/insurance_h250px_case1%402x.png',
    title: '在线理赔小程序',
    route: '/case/detail?id=2'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/insurance_case2%402x.png',
    title: '智能查勘平台',
    route: '/case/detail?id=3'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/insurance_case3%402x.png',
    title: '理财分销系统',
    route: '/case/detail?id=1'
  }]
}, {
  id: 2,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_2%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/city_banner%402x.png',
  title: '互联网+智慧城市',
  desc: '针对智慧城市：从市政服务层面，建设体系化移动城市应用，增加移动端的政府信息公开渠道、民生办事服务渠道，及覆盖开发区内衣食住行的智能建设，将城市中的每一个人连接起来，建立城市主数据，完善数据云的建设，从而进行数据应用，能够对人群有效监管，让人们生活更便利更安全。',
  program: [{
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/city_h250px_case_1%402x.png',
    title: '旅游经济开发区小程序'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/city_case_2%402x.png',
    title: '智慧微门户小程序',
    route: '/case/detail?id=4'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/city_case_3%402x.png',
    title: '智慧台账系统',
    route: '/case/detail?id=5'
  }]
}, {
  id: 3,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_3%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_bnaner%402x.png',
  title: '互联网+智能财税',
  desc: '将财税业务整合互联网技术，实现智能化财税服务，帮助财税企业扩充服务渠道、提升财税企业工作效率，提供线上财税咨询、财税课程咨询、财税服务购买、以及线上财税业务推广等功能，帮助财税企业打造智能化、高效化、规范化财税服务。',
  program: [{
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_h250px_case_1%402x.png',
    title: '智慧学院小程序',
    route: '/case/detail?id=6'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/cs_case_2%402x.png',
    title: '财税云小程序',
    route: '/case/detail?id=7'
  }]
}, {
  id: 4,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_4%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/tourism_banner%402x.png',
  title: '互联网+智慧旅游',
  desc: '针对旅游景区于旅游城市：建设景区名片管理平台、电子票务平台、智慧景区服务平台、特产电商平台、互动营销平台等智能应用，为旅游区建立积分商城系统，用于推广景区内部特产，为景区推广提供有力渠道。',
  program: [{
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/tourism_h250px_case_1%402x.png',
    title: '智慧旅游景区',
    route: '/case/detail?id=9'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/tourism_h_250px_case_2%402x.png',
    title: '多彩旅游圈小程序',
    route: '/case/detail?id=8'
  }]
}, {
  id: 5,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_5%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/medical_h560_baner%402x.png',
  title: '互联网+智慧医疗',
  desc: '开发中医诊所后台管理平台，实现中医药品在线进销存管理，医生问诊管理，费用结算管理，为中医诊所提供药品进货、库存添加、医生管理与问诊一整套的线上服务，规范药品管理、患者问诊流程，提升诊所服务效率。',
  program: [{
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/medical_h250px_case_1%402x.png',
    title: '中医后台管理与服务平台',
    route: '/case/detail?id=11'
  }, {
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/medical_h250px_case_2%402x.png',
    title: '智慧医疗小程序',
    route: '/case/detail?id=10'
  }]
}, {
  id: 6,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_6%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/finance_h560px_banner%402x.png',
  title: '互联网+财务',
  desc: '开发智慧财务系统，将财务凭证进行在线组卷与归档管理，省去人工组卷的工作量，并是组卷操作有迹可循，系统自动设定组卷规则，财务人员只需一个按钮就可以完成组卷工作。',
  program: [{
    poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/finance_h250px_case%402x.png',
    title: '财务凭证组卷系统',
    route: '/case/detail?id=12'
  }]
}, {
  id: 7,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_7%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/education_h560px_banner%402x.png',
  title: '互联网+教育',
  desc: '名师库，金牌名师实力详解，为网校强力背书。学员可对课程进行评价和评论；支持多形式分享课程，让课程主动传播。教师实时掌握教学况及进度，学员清晰课程学习记录和进度。支持讨论、评论、问答、在线咨询等多方式的师生互动。'
}, {
  id: 8,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_8%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/yq_banner%402x.png',
  title: '互联网+智慧园区',
  desc: '通过平台与政务中心打通信息接口，实现政府对园区、企业政策及时下发，园区、企业信息及时上报。为政府管理园区及企业，提供高效、实时、安全的管理手段，以高效和微调方式对园区进行快速辐射和推广。强化园区招商引资能力，进一步提升行业形象。'
}, {
  id: 9,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_9%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/ds_h560px_banner%402x.png',
  title: '互联网+电商',
  desc: '针对大型综合商业体/购物中心，提供开展多商家多业态特征电商业务的系统解决方案，结合多商家在线销售和多业态互联网自服务应用的平台业务，建立统一会员机制，打造消费者在线沟通能力，实现商客关系的掌握，持续开展以综合商业体为核心的客户忠诚度管理。'
}, {
  id: 10,
  poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/program_image_10%402x.png',
  banner: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/estate_h560px_banner%402x.png',
  title: '互联网+地产',
  desc: '互联网+房产运用平台化运行，合理把控各项数据，利用互联网去中心化的能力实现企业在传播、销售、社区服务等领域的突破和创新，从而提升企业经营效益和客户满意度。'
}]

function getItem(id) {
  return list.find(item => item.id === id)
}

export {
  list,
  getItem
}


// WEBPACK FOOTER //
// ./src/components/solution/data.js